<template lang="pug">
.view-helpdesk
  form-modal(form="notification-form" v-model="notificationMessage" title="Оповещение для всех клиентов" @save="storeUpdatingNotification()" @close="closeNotificationModal()" :active.sync="isNotificationModalActive")

  ui-navbar-panel
    b-field(slot="filters", grouped, group-multiline)
      b-field
        .control: b-radio-button(
          :value="filter.active",
          @input="setFilter('active', $event)",
          native-value="1",
          type="is-primary"
        ) Активные
        .control: b-radio-button(
          :value="filter.active",
          @input="setFilter('active', $event)",
          native-value="2",
          type="is-primary"
        ) Неактивные
        .control: b-radio-button(
          :value="filter.active",
          @input="setFilter('active', $event)",
          native-value="0",
          type="is-primary"
        ) Закрытые

      .control: b-button.ml-20(
        :type="visibleFilters ? 'is-primary' : ''",
        icon-left="filter",
        @click="toggleFilterPanel"
      ) Фильтры

      .control: b-dropdown.ml-10(position="is-bottom-left")
        b-button(slot="trigger", icon-left="table")
          span Колонки
          b-icon(icon="menu-down")
        .dropdown-item
          b-field(v-for="(column, index) in columns", :key="index")
            b-checkbox(v-model="column.visible") {{ column.title }}

      .control: b-input.ml-10(
        type="text",
        v-model="search",
        autocomplete="off",
        placeholder="Поиск..."
      )

      .control: b-tooltip(label="Сбросить текстовый поиск" v-if="isResetSearch")
        b-button(type="is-light", icon-left="close", @click="resetSearch()")

      .control(v-if="user.isSupport"): b-tooltip(label="Перейти на страницу тикета или задачи" v-if="isResetSearch")
        b-button(type="is-light", icon-left="arrow-right", @click="routeToTaskBySearchId()")

    b-tooltip(v-if="user.isSupport && !notification", label="Сообщить клиентам об обновлении системы или другую новость", position="is-left", type="is-dark")
      b-icon.mr-3.pr-3.is-clickable(icon="comment-alert-outline", type="is-primary", @click.native="startUpdatingNotification")
    router-link(:to="{ name: 'newTask' }")
      b-button(type="is-primary", icon-left="plus-circle") Новый тикет

  ui-navbar-panel.has-background-grey-lighter.pt-10(v-if="visibleFilters")
    b-field(slot="filters", grouped, group-multiline)
      //- Platform
      select-platform(
        v-if="user.isSupport",
        :value="filter.platform_id",
        type="active",
        @input="setFilter('platform_id', $event)",
        with-reset
      )

      select-task-status(
        :value="filter.status_id",
        @input="setFilter('status_id', $event)",
         with-reset
      )

      select-label(
        :value="filter.label_id",
        @input="setFilter('label_id', $event)",
        type="task",
        placeholder="Тип",
        with-reset
      )

      //- Executor
      select-executor(
        v-if="user.isSupport",
        :value="filter.executor_id",
        @input="setFilter('executor_id', $event)",
        placeholder="Ответственный",
        with-reset
        is-filter-mode
      )

      b-select(v-if="user.isSupport", v-model="filterPriority", placeholder="Все приоритеты")
        option(v-for="(priority, key) in ['Все приоритеты', 'Приоритет 1', 'Приоритет 2', 'Приоритет 3']" :value="key" :key="key")
          | {{ priority }}

      b-taginput(v-if="user.isSupport", v-model="filterTags", :data="filteredTags", ref="taginput", :allow-new="false", autocomplete, icon="label" :placeholder="this.filterTags.length ? 'Добавить' : 'Метки'", @typing="getFilteredTags")
        template(slot-scope="props")
          | {{ props.option.name }}
        template(#empty)
          | Метки не найдены
        template(#selected="props")
          b-tag(v-for="(tag, index) in props.tags", :key="index", rounded, :type="getType(tag)", :tabstop="false", ellipsis, closable, @close="$refs.taginput.removeTag(index, $event)")
            | {{ tag.name }}

      b-select(v-if="user.isSupport", v-model="filterCustom", placeholder="Все тикеты")
        option(value="0")
          | Все тикеты
        option(value="more2days")
          | Ожидают ответ более суток
        option(value="more2weeks")
          | Не закрыты более двух недель

      b-tooltip(label="Сбросить фильтр")
        b-button(type="is-light", icon-left="close", @click="resetFilter()")

  b-message.m-3(v-if="notification", type="is-info" has-icon)
    p(v-html="notification.value ? notification.value.message : 'Идет обновление системы'")
    p(v-if="user.isSupport")
      b-button.is-pulled-right.is-small.mt-2(type="is-primary", @click="deleteUpdatingNotification()") Удалить
      br
      span.has-text-primary Сообщение автоматически удалится {{ notification.actual_to | dateFormat }}

  //- Table
  b-table.is-clickable(
    v-if="tasks",
    :data="tasks.items",
    :row-class="tableRowClass",
    :loading="tasks.$state.loading",
    :mobile-cards="false",
    default-sort="updated_at",
    default-sort-direction="desc",
    :current-page="numericPage",
    :per-page="perPage",
    :total="totalTasks",
    backend-sorting,
    backend-pagination,
    paginated,
    pagination-simple,
    hoverable,
    @click="routeToTask",
    @sort="tableSort",
    @page-change="tablePageRange"
  )
    template(slot="empty")
      section.section
        .content.has-text-grey.has-text-centered
          template(v-if="tasks.$state.loaded")
            p: b-icon(icon="emoticon-sad", size="is-large")
            p Нет ни одной записи

    //- ID
    b-table-column.has-text-grey(field="id", label="#", :visible="columns.id.visible", width="1", numeric, sortable, v-slot="{row}") {{ row.id }}

    //- Статус
    b-table-column.pr-0(
      field="status_id",
      label=" ",
      :visible="columns.status_id.visible",
      width="1",
      sortable,
      nowrap,
      v-slot="{row}"
    )
      task-status(v-if="row.status", :status="row.status", tooltip-position="is-right", icon-only, @click.native="filterByStatus(row.status_id, $event)")

    //- Тема
    b-table-column(
      field="title",
      label="Тема",
      sortable,
      v-slot="{row}"
    )
      b-icon(v-if="needToProcess(row)", icon="circle-medium", type="is-link")
      b-icon(v-else, icon="circle-medium", type="is-light")
      span(:class="needBoldTheme(row) ? 'has-text-weight-bold' : 'has-text-grey'") {{ row.title }}

    //- Ответственный
    b-table-column(
      field="executor_id",
      label="Ответственный",
      :visible="user.isSupport && columns.executor.visible",
      sortable,
      v-slot="{row}"
    )
      b-tag(v-if="row.executor_id", :type="row.executor_id == user.id ? 'is-link' : ''", @click.native="filterByExecutor(row.executor_id, $event)") {{ row.executor.fullName }}

    //- Платформа
    b-table-column(
      field="platform_id",
      label="Платформа",
      :visible="user.isSupport && columns.platform.visible",
      sortable,
      v-slot="{row}"
    )
      platform-label.mr-5(v-if="row.platform_id", :platform="row.platform", with-priority, @click.native="filterByPlatform(row.platform_id, $event)")

    //- Метки
    b-table-column(
      field="tags",
      label="Метки",
      :visible="user.isSupport && columns.tags.visible",
      v-slot="{row}"
    )
      .tags
        span(v-for="tag in row.tags" :class="'mr-1 tag ' + tag.color", @click="filterByTag(tag, $event)")
          | {{ tag.name }}

    //- Файлы
    b-table-column(field="allFilesCount", label="Файлы", :visible="columns.allFilesCount.visible", width="1", nowrap, v-slot="{row}")
      template(v-if="row.allFiles && row.allFilesCount > 0")
        b-icon.mx-5(icon="attachment")
        small.has-text-grey(v-if="row.allFilesCount > 1") {{ row.allFilesCount }}

    //- Комментарии
    b-table-column(field="messagesCount", :visible="columns.messagesCount.visible", label="  ", width="80", nowrap, v-slot="{row}")
      //- template(slot="header")
      //-   b-icon.mr-5(icon="comment-multiple-outline", type="is-grey")
      template(v-if="row.messages && row.messagesCount")
        b-tooltip(:label="row.lastActivityUser ? row.lastActivityUser.fullName : ''")
          b-icon.mr-5(icon="comment-multiple-outline", type="is-grey")
          small.mr-5.has-text-grey(v-if="row.messagesCount > 1") {{ row.messagesCount }}

    //- Активность
    b-table-column(
      field="updated_at",
      label="Активность",
      :visible="columns.updated_at.visible",
      width="140",
      sortable,
      nowrap,
      v-slot="{row}"
    )
      small {{ row.updated_at | dateToNow(true) }}

    //- Автор
    b-table-column(field="author", label="Автор", :visible="columns.author.visible", width="1", nowrap, sortable, v-slot="{row}")
      b-tooltip(v-if="row.author", :label="row.author.role.title")
        user-name(:user="row.author")

    //- Дата создания
    b-table-column(
      field="created_at",
      label="Создан",
      :visible="columns.created_at.visible",
      width="1",
      nowrap,
      sortable,
      v-slot="{row}"
    )
      small {{ row.created_at | dateFormat }}

    //- Дэдлайн
    b-table-column(
      field="deadline_at",
      label="Дедлайн",
      :visible="columns.deadline_at.visible",
      width="1",
      nowrap,
      sortable,
      v-slot="{row}"
    )
      template(v-if="row.deadline_at")
        b-tag.is-info {{ row.deadline_at | dateToNow(true) }}

    //- Тип
    b-table-column.has-text-centered(
      field="label_id",
      label="Тип",
      :visible="columns.label_id.visible",
      width="1",
      sortable,
      nowrap,
      v-slot="{row}"
    )
      ui-label(:label="row.label", tooltip-position="is-left", icon-only, @click.native="filterByLabel(row.label_id, $event)")

</template>

<script>
import Task from '@/models/Task';
import Tag from '@/models/Tag';
import { mapGetters } from 'vuex';
import BTableColumn from 'buefy/src/components/table/TableColumn';
import BTooltip from 'buefy/src/components/tooltip/Tooltip';
import BSwitch from 'buefy/src/components/switch/Switch';
import {ToastProgrammatic as Toast} from 'buefy';
import api from '@/api';

export default {
  name: 'view-helpdesk',

  components: { BSwitch, BTooltip, BTableColumn },

  data: () => ({
    tasks: Task.collection(),
    btnFiltersActive: false,
    search: '',

    totalTasks: 0,
    perPage: 30,
    renderCount: 0,

    filterPriority: 0,
    filterCustom: 0,
    filterTags: [],
    tags: Tag.collection(),
    filteredTags: [],
    backdoor: 0,
    isResetSearch: false,
    isTaskExistsBySearchId: false,
    isNotificationModalActive: false,
    notification: null,
    notificationMessage: {
      message: null,
      default: 'В данный момент у всех пользователей Медпред CRM происходит обновление системы. В случае некорректной работы им следует обновить страницу в браузере через несколько минут',
    },

    columns: {
      id: { visible: true, title: 'Идентификатор' },
      status_id: { visible: true, title: 'Статус' },
      platform: { visible: true, title: 'Платформа' },
      tags: { visible: true, title: 'Метки' },
      allFilesCount: { visible: false, title: 'Файлы' },
      messagesCount: { visible: true, title: 'Комментарии' },
      updated_at: { visible: true, title: 'Последняя активность' },
      author: { visible: false, title: 'Автор' },
      executor: { visible: true, title: 'Ответственный' },
      label_id: { visible: true, title: 'Тип' },
      created_at: { visible: false, title: 'Дата создания' },
      deadline_at: { visible: true, title: 'Дэдлайн' },
    },
    // filter: {},
  }),

  computed: {
    ...mapGetters(['user']),

    query() {
      this.backdoor;
      return {
        page: 1,
        sort: '-updated_at',
        ...this.$route.query,
      };
    },

    filter() {
      let filter = {};
      if (this.query && this.query.filter) {
        filter = JSON.parse(this.query.filter);
      } else if (localStorage.hasOwnProperty('helpdesk_filter')) {
        filter = JSON.parse(localStorage.getItem('helpdesk_filter'));
      }

      return {
        active: '1',
        ...filter,
      };
    },

    visibleFilters() {
      return this.btnFiltersActive || Object.keys(this.filter).length > 1 ||
        (localStorage.hasOwnProperty('helpdesk_filter') &&
          Object.keys(JSON.parse(localStorage.getItem('helpdesk_filter'))).length > 1);
    },

    numericPage() {
      return this.query.page > 0 ? Number.parseInt(this.query.page) : 0;
    },

    filterTagIds() {
      let ids = [];
      for (let tag of this.filterTags) {
        ids.push(tag.id);
      }
      return ids;
    },
  },

  watch: {
    query() {
      this.loadState();
    },

    search() {
      this.isResetSearch = this.search !== '';
      this.loadState();
      if (this.user.isSupport) {
        api
          .for('tasks')
          .read('is-exists', {id: this.search.trim()})
          .then((response) => {
            this.isTaskExistsBySearchId = response.is_exists;
          });
      }
    },

    filterPriority() {
      if (this.filterPriority === 0) {
        this.setFilter('priority', undefined);
      } else {
        this.setFilter('priority', this.filterPriority);
      }
    },

    filterCustom() {
      if (this.filterCustom === 0) {
        this.setFilter('custom', undefined);
      } else {
        this.setFilter('custom', this.filterCustom);
      }
    },

    filterTags() {
      if (this.filterTagIds.length) {
        this.setFilter('tags', JSON.stringify(this.filterTagIds));
      } else {
        this.setFilter('tags', undefined);
      }
    },
  },

  methods: {
    loadState() {
      return this.tasks
        .$fetch({
          include: 'status,label,author.role,executor,platform.label,allFiles,messages.user,tags',
          page: this.query.page,
          sort: this.query.sort,
          filter: this.getFilterForApi(),
          limit: this.perPage,
          scope: this.getTasksScope(),
        })
        .then(({ meta }) => {
          this.perPage = meta.per_page;
          this.totalTasks = meta.total;
          this.loadNotification();
        });
    },

    loadNotification() {
      api
        .for('settings')
        .read('updating-notification')
        .then((response) => {
          this.notification = response.notification;
        });
    },

    deleteUpdatingNotification() {
      api
        .for('settings')
        .read('delete-updating-notification')
        .then((response) => {
          this.notificationMessage.message = this.notificationMessage.default;
          this.notification = null;
        });
    },

    filterByPlatform(platformId, event) {
      event.stopPropagation();
      this.setFilter('platform_id', platformId);
    },

    filterByStatus(statusId, event) {
      event.stopPropagation();
      this.setFilter('status_id', statusId);
    },

    filterByLabel(labelId, event) {
      event.stopPropagation();
      this.setFilter('label_id', labelId);
    },

    filterByTag(tag, event) {
      event.stopPropagation();
      this.filterTags = [tag];
    },

    filterByExecutor(executorId, event) {
      event.stopPropagation();
      this.setFilter('executor_id', executorId);
    },

    startUpdatingNotification() {
      if (this.user.isSupport) {
        this.notificationMessage.message = this.notificationMessage.default;
        this.isNotificationModalActive = true;
      }
    },

    storeUpdatingNotification() {
      this.isNotificationModalActive = false;
      api
        .for('settings')
        .read('start-updating-notification', {msg: this.notificationMessage.message})
        .then((response) => {
          this.notificationMessage.message = this.notificationMessage.default;
          this.loadNotification();
        });
    },

    closeNotificationModal() {
      this.isNotificationModalActive = false;
    },

    getFilterForApi() {
      let filter = this.filter;
      if (filter.hasOwnProperty('priority')) {
        delete filter['priority'];
      }
      if (filter.hasOwnProperty('tags')) {
        delete filter['tags'];
      }
      if (filter.hasOwnProperty('custom')) {
        delete filter['custom'];
      }
      return filter;
    },

    getTasksScope() {
      const priority = this.filterPriority === 0 ? '' : ('platformPriority:' + this.filterPriority + ',');
      const custom = this.filterCustom === 0 ? '' : ('customFilter:' + this.filterCustom + ',');
      const tags = this.filterTagIds.length ? 'tagsByIds:' + this.filterTagIds.join(':') + ',' : '';
      return custom + tags + priority + 'helpdesk,search:' + this.search;
    },

    tableRowClass({ status }) {
      if (status) {
        return {
          'has-background-light has-text-grey': status.isClosed,
        };
      }
    },

    routeToTask({ id }) {
      this.$router.push({name: 'task', params: {id}});
    },

    routeToTaskBySearchId() {
      const id = this.search.trim();
      if (parseInt(id) !== +id) {
        Toast.open({
          type: 'is-danger',
          duration: 4000,
          message: 'Недопустимый номер тикета',
          queue: false,
        });
        return;
      }
      if (!this.isTaskExistsBySearchId) {
        Toast.open({
          type: 'is-danger',
          duration: 4000,
          message: 'Тикет и задача с таким номером не существуют',
          queue: false,
        });
        return;
      }

      window.open(this.$router.resolve({name: 'task', params: {id}}).href);
    },

    needBoldTheme(task) {
      if (task.status && task.status.isTypeWait) {
        return false;
      }
      return this.needToProcess(task);
    },

    needToProcess(task) {
      if (task.status && (task.status.isClosed || task.status.isTypeFuture || task.status.isTypeDeployment)) {
        return false;
      }
      return task.lastActivityUser && task.lastActivityUser.role_id != this.user.role_id;
    },

    setQueryParam(key, value) {
      let query = { ...this.$route.query };
      if (!(query.hasOwnProperty(key) && query[key] === value)) {
        query[key] = value;
        this.$router.push({ query });
      } else {
        this.loadState();
      }
    },

    resetSearch() {
      this.search = '';
    },

    resetFilter() {
      localStorage.removeItem('helpdesk_filter');
      this.filterPriority = 0;
      this.filterTags = [];
      this.filterCustom = 0;
      if (Object.keys(this.$route.query).length) {
        this.$router.push({name: 'helpdesk'});
      } else if (Object.keys(this.filter).length > 1) {
        this.$router.go(0);
      }
    },

    setFilter(field, value) {
      this.backdoor++;

      let filter = { ...this.filter };

      if (value || value === 0) {
        filter[field] = value;
      } else {
        delete filter[field];
      }

      localStorage.setItem('helpdesk_filter', JSON.stringify(filter));

      this.setQueryParam('filter', JSON.stringify(filter));
    },

    tableSort(field, direction) {
      this.setQueryParam('sort', (direction == 'desc' ? '-' : '') + field);
    },

    tablePageRange(page) {
      this.setQueryParam('page', page);
    },

    toggleFilterPanel() {
      this.btnFiltersActive = !this.btnFiltersActive;
    },

    getFilteredTags(text) {
      const tags = this.tags.items.filter((option) => {
        for (let tag of this.filterTags) {
          if (tag.id === option.id) {
            return false;
          }
        }
        return true;
      });

      this.filteredTags = tags.filter((option) => {
        return option.name
          .toString()
          .toLowerCase()
          .indexOf(text.toLowerCase()) >= 0;
      })
    },

    getType(tag) {
      return tag.color;
    }
  },

  created() {
    this.tags.$fetch({
      sort: 'name',
      scope: 'active',
    }).then(() => {
      if (localStorage.hasOwnProperty('helpdesk_filter')) {
        const filter = localStorage.getItem('helpdesk_filter');
        const filterObject = JSON.parse(filter);
        if (filterObject.hasOwnProperty('priority')) {
          this.filterPriority = filterObject.priority;
        }
        if (filterObject.hasOwnProperty('tags')) {
          const filterTagIds = JSON.parse(filterObject.tags);
          this.filterTags = [];
          for (let tagId of filterTagIds) {
            for (let tag of this.tags.items) {
              if (tag.id === tagId) {
                this.filterTags.push(tag);
              }
            }
          }
        }
        if (filterObject.hasOwnProperty('custom')) {
          this.filterCustom = filterObject.custom;
        }
        this.setQueryParam('filter', filter);
      } else {
        this.loadState();
      }
    });
  },

  updated: function () {
    this.$nextTick(() => {
      this.renderCount++;
      if (this.renderCount === 1 && this.$route.query.tasks) {
        this.resetFilter();
        this.loadState();
      }
    })
  }
};
</script>
